import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import LOGO_VISIONFLOW from "assets/images/logo_visionflow.png";

export default function Header() {
  const [headerClass, setHeaderClass] = useState("app-header");
  const location = useLocation();

  useEffect(() => {
    let tempClass = "";
    if (location.pathname === "/works") {
      tempClass = "app-header is-bg-darkgray";
    } else if (
      location.pathname === "/contact" ||
      location.pathname === "/feeds"
    ) {
      tempClass = "app-header is-bg-gray";
    } else {
      tempClass = "app-header";
    }
    console.log("tempClass >>", tempClass);
    setHeaderClass(tempClass);
  }, [location.pathname]);

  const getActiveClass = (path) => {
    return location.pathname === path ? "active" : "";
  };

  return (
    <header className={headerClass}>
      <h1>
        <Link to="/">
          <img src={LOGO_VISIONFLOW} className="app-logo" alt="VisionFlow" />
        </Link>
      </h1>
      <nav className="app-nav">
        <Link to="/works" className={getActiveClass("/works")}>
          WORKS
        </Link>
        <span className="sub">
          <strong>SERVICES</strong>
          <Link
            to="/services/frontend"
            className={getActiveClass("/services/frontend")}
          >
            Front-end
          </Link>
          <Link to="/services/ai" className={getActiveClass("/services/ai")}>
            Gen AI Image
          </Link>
        </span>
        <Link to="/about" className={getActiveClass("/about")}>
          ABOUT
        </Link>
        <Link to="/contact" className={getActiveClass("/contact")}>
          CONTACT
        </Link>
      </nav>
    </header>
  );
}
